import React from 'react';

export default function Maintenance() {
  return (
    <div
      style={{
        background: `url("https://storage.googleapis.com/showroom-bucket-images/SS26/Home/Who_We_Are.jpg") no-repeat center top / cover`,
        height: '100vh',
        width: '100vw',
        color: 'white',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.3)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <h1>
          We are under maintenance. <br />
          Come back soon!
        </h1>
      </div>
    </div>
  );
}
